import script from "./ArgonAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonAvatar.vue?vue&type=script&setup=true&lang=js"

import "./ArgonAvatar.vue?vue&type=style&index=0&id=0d7f122c&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d7f122c"]])

export default __exports__